import {createContext} from "react";

const BreakpointsContext = createContext(null);

export default BreakpointsContext;